export const CADESCOM_CADES_X_LONG_TYPE_1 = 0x5d;
export const CAPICOM_CURRENT_USER_STORE = 2;
export const CAPICOM_MY_STORE = 'My';
export const CAPICOM_STORE_OPEN_MAXIMUM_ALLOWED = 2;
export const CAPICOM_CERTIFICATE_FIND_SUBJECT_NAME = 1;
export const CAPICOM_CERT_INFO_SUBJECT_SIMPLE_NAME = 0;
export const CAPICOM_CERT_INFO_ISSUER_SIMPLE_NAME = 1;
export const CADESCOM_BASE64_TO_BINARY = 1;
export const CAPICOM_CERTIFICATE_INCLUDE_WHOLE_CHAIN = 1;
export const CADESCOM_CADES_BES = 1;
export const CADESCOM_PKCS7_TYPE = 0xffff;
export const CAPICOM_AUTHENTICATED_ATTRIBUTE_SIGNING_TIME = 0;
export const CADESCOM_AUTHENTICATED_ATTRIBUTE_DOCUMENT_NAME = 1;
export const LOADING_DELAY = 500;
export const CADESCOM_XML_SIGNATURE_TYPE_ENVELOPED = 0;
export const CADESCOM_XML_SIGNATURE_TYPE_TEMPLATE = 2;
export const CADESCOM_ENCODE_BASE64 = 0;
export const XmlDsigGost3411Url2012256 = 'urn:ietf:params:xml:ns:cpxmlsec:algorithms:gostr34112012-256';
export const XmlDsigGost3410Url2012256 = 'urn:ietf:params:xml:ns:cpxmlsec:algorithms:gostr34102012-gostr34112012-256';
